import { Box, Stack } from "@mui/material";
import {
  AcquisitionMiniCard,
  AcquisitionSummaryCard,
} from "./AcquisitionCards";

export default function Acquisition() {
  return (
    <Box>
      <Stack spacing={2}>
        <AcquisitionSummaryCard
          title="Spend"
          value="$949,697"
          total="$1,178,063"
          rr="115.1%"
          prr="$1,356,710"
        />

        <Stack direction="row" spacing={2}>
          <AcquisitionMiniCard
            title="CLICKS"
            value="31,605"
            total="127,052"
            rr="51.8%"
            pr="45,877"
            rrColor="error"
          />

          <AcquisitionMiniCard
            title="CONVERSIONS"
            value="13.72%"
            total="13.14%"
            rr="104.4%"
            pr="13.72%"
            rrColor="success"
          />
        </Stack>
      </Stack>
    </Box>
  );
}
